// function to add conditinal styling class names
export const classNames = (...args) => {
  return args.filter(Boolean).join(' ');
};
